module.exports = "/_next/static/images/TeamPlan-sm-9a4910eb4141d352af54fb0e6056d052.png";